import script from "./AssignmentAlertModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssignmentAlertModal.vue?vue&type=script&setup=true&lang=ts"

import "./AssignmentAlertModal.vue?vue&type=style&index=0&id=5c721b2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c721b2c"]])

export default __exports__